export default import.meta.ROLLUP_FILE_URL_CjAr9f1r;